// Enhanced custom renderers with expandable sections
    const customRenderers = {
        img: ({node, ...props}) => (
            <img {...props} className="max-w-full md:max-w-[70%] h-auto my-4 mx-auto rounded-md shadow-md" loading="lazy" />
        ),
        p: ({node, ...props}) => (
            <p {...props} className="my-3 leading-relaxed" />
        ),
        h1: ({node, children, ...props}) => (
            <h1 {...props} className="text-3xl font-bold mt-8 mb-4 text-gray-900 dark:text-gray-100 border-b border-gray-300 dark:border-gray-600 pb-2">
                {children}
            </h1>
        ),
        h2: ({node, children, ...props}) => (
            <h2 {...props} className="text-2xl font-bold mt-6 mb-3 text-gray-900 dark:text-gray-100">
                {children}
            </h2>
        ),
        h3: ({node, children, ...props}) => (
            <h3 {...props} className="text-xl font-semibold mt-5 mb-3 text-gray-900 dark:text-gray-100">
                {children}
            </h3>
        ),
        // Add support for HTML details/summary tags that users might write directly
        details: ({node, ...props}) => (
            <details {...props} className="my-4 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden bg-white dark:bg-gray-800" />
        ),
        summary: ({node, children, ...props}) => {
            return (
                <summary {...props} className="bg-gray-50 dark:bg-gray-700 px-4 py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors font-medium flex items-center select-none">
                    <span className="expandable-arrow mr-2 transition-transform duration-200">▶</span>
                    <span className="text-gray-900 dark:text-gray-100">{children}</span>
                </summary>
            );
        },
        ul: ({node, ...props}) => (
            <ul {...props} className="list-disc pl-6 my-4 space-y-1" />
        ),
        ol: ({node, ...props}) => (
            <ol {...props} className="list-decimal pl-6 my-4 space-y-1" />
        ),
        li: ({node, ...props}) => (
            <li {...props} className="ml-2 mb-1.5" />
        ),
        pre: ({node, ...props}) => (
            <pre {...props} className="bg-gray-100 dark:bg-gray-800 p-4 rounded-md overflow-x-auto my-4 text-sm" />
        ),
        code: ({node, inline, ...props}) => (
            inline 
                ? <code {...props} className="bg-gray-100 dark:bg-gray-800 px-1.5 py-0.5 rounded text-sm font-mono" />
                : <code {...props} className="block font-mono" />
        ),
        a: ({node, ...props}) => (
            <a {...props} className="text-blue-600 dark:text-blue-400 hover:underline" target="_blank" rel="noopener noreferrer" />
        ),
        table: ({node, ...props}) => (
            <div className="overflow-x-auto my-4">
                <table {...props} className="min-w-full border dark:border-gray-700 rounded-md" />
            </div>
        ),
        thead: ({node, ...props}) => (
            <thead {...props} className="bg-gray-100 dark:bg-gray-800" />
        ),
        th: ({node, ...props}) => (
            <th {...props} className="py-2 px-4 border-b dark:border-gray-700 text-left font-semibold" />
        ),
        td: ({node, ...props}) => (
            <td {...props} className="py-2 px-4 border-b dark:border-gray-700" />
        ),
    };

export default customRenderers;